import { DurationCalculatorItemBase } from "../json-schemas/base/duration_calculator_item"
import { I18nService } from "../utils/i18n.service"
import i18nScopedData from './duration-calculator-items.service.yml'

const i18nScoped = new I18nService(i18nScopedData)

export function durationCalculatorItemsI18nValue (definition: DurationCalculatorItemBase['definition'], quantity: number) {
  if (!definition.unit) return null

  if (typeof definition.unit === 'object') {
    const unit = definition.unit[quantity <= 1 ? 'singular_text' : 'plural_text']
    return `${quantity} ${unit}`
  }

  return `${quantity} ${i18nScoped.t(`unit_symbol.${definition.unit}`)}`
}
